<template>
  <appHeader> </appHeader>
  <!-- banner section -->
  <section class="w3l-banner-background" style="padding-top: 130px">
    <div class="container">
      <div class="my-blur-mask" />
      <div class="my-msg" v-show="showMsg">
        <messages @saveMessage="handleMessageSave"></messages>
      </div>
      <div
        v-show="!showMsg"
        class="row"
        style="
          margin: 0 auto;
          height: 750px;
          align-items: center;
          justify-content: center;
        "
      >
        <div class="mypet-container">
          <div class="mypet mypet-left">
            <photoCrop @crop="handleCrop" v-model="petform.petPhoto"></photoCrop>
          </div>
          <div class="mypet mypet-right">
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Name:</div>
                <input
                  type="text"
                  class="text-item"
                  v-model="petform.petName"
                  maxlength="100"
                  placeholder="Please enter pet name"
                />
              </div>
            </div>
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Birthdate:</div>
                <VueDatePicker
                  v-model="petform.petBirthDate"
                  :mobile-mode="true"
                  :mobile-breakpoint="768"
                  placeholder="Select date"
                  format="yyyy-MM-dd"
                  display-format="yyyy-MM-dd"
                  :enable-time-picker="false"
                  model-type="yyyy-MM-dd"
                />
              </div>
            </div>
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Type:</div>
                <div class="pet-type">
                  <div
                    class="type-item"
                    :class="{ active: petform.petType === 'cat' }"
                    @click="setPetType('cat')"
                  >
                    <img
                      v-if="petform.petType === 'cat'"
                      src="@/assets/images/catc.png"
                      class="tag-pic"
                    />
                    <img
                      v-else
                      src="@/assets/images/catw.png"
                      class="tag-pic"
                    />
                    <text>Cat</text>
                  </div>

                  <div
                    class="type-item"
                    :class="{ active: petform.petType === 'dog' }"
                    @click="setPetType('dog')"
                  >
                    <img
                      v-if="petform.petType === 'dog'"
                      src="@/assets/images/dogc.png"
                      class="tag-pic"
                    />
                    <img
                      v-else
                      src="@/assets/images/dogw.png"
                      class="tag-pic"
                    />
                    <text>Dog</text>
                  </div>
                  <div
                    class="type-item"
                    :class="{ active: petform.petType === 'other' }"
                    @click="setPetType('other')"
                  >
                    <text>Other</text>
                  </div>
                </div>
              </div>
            </div>
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Breed:</div>
                <div style="flex: 1; display: flex">
                  <curryMultiSelect
                    :items="breedItems"
                    v-model="petform.petCategory"
  
                  />
                </div>
              </div>
            </div>
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Email:</div>
                <input
                  type="text"
                  class="text-item"
                  @blur="validateEmail"
                  v-model="petform.petMail"
                  maxlength="100"
                  placeholder="Please enter email"
                />
              </div>
            </div>
            <div class="mypet-right-items">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Tel:</div>
                <!-- <input type="text" class="text-item" v-model="petform.petPhone" /> -->
                <div style="flex: 1; display: flex">
                  <telareaview
                    @telselect="handleSelectCode"
                    :currItem="selectItem"
                    :items="localeItems"
                    v-model="petform.petPhone"
                  />
                </div>
              </div>
            </div>
            <div class="mypet-right-items" style="margin-top: 5px">
              <div class="mypet-right-item">
                <div class="mypet-right-item-title">Message:</div>
                <textarea
                  class="text-item"
                  v-model="petform.petMark"
                  maxlength="200"
                  @click="openMsg"
                  placeholder="Click and select message"
                >
                </textarea>
              </div>
            </div>
            <div class="mypet-right-items btn">
              <button class="action-item-phone btn2" @click="submit">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { api } from "@/assets/js/requests";
import appHeader from "@/components/appHeader.vue";
import curryMultiSelect from "@/components/curry-multi-select.vue";
import messages from "@/components/MessagesView.vue";
import photoCrop from "@/components/photoCapture.vue";
import telareaview from "@/components/TelAreaSelect.vue";
// import { DatePicker } from "@bturkis/datepicker";
import "@bturkis/datepicker/style.css";
export default {
  name: "appHome",
  components: {
    appHeader,
    // DatePicker,
    messages,
    telareaview,
    curryMultiSelect,
    photoCrop,
  },
};
</script>
<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";

const petform = ref({
  phoneLocale: "be",
});
const showMsg = ref(false);

const selectItem = ref({
  countryFlag: "-1px -69px",
  countryName: "UnitedStates",
  countryCode: "+1",
  shortName: "us",
});

const petPhoto = ref('')


const breedItems = ref([]);
const route = useRoute();

onMounted(async () => {
  const petid = route.query.petid;
  if(!localStorage.getItem("token")){
    location.href="/idtags?petid="+petid
    return;
  }
  petform.value.petZcode = useRoute().query.petid;
  const expireTime = localStorage.getItem("cacheExpire");
  if (expireTime && Date.now() > parseInt(expireTime)) {
    localStorage.removeItem("cachedHomePics");
    localStorage.removeItem("cacheExpire");
  }
  await loadLocaleItems();
});

onUnmounted(() => {
  // 清理定时器

  // 清理动态样式
  const styleElement = document.getElementById("dynamic-backgrounds");
  if (styleElement) {
    styleElement.remove();
  }
});

const validateEmail = () => {
  if (
    petform.value.petMail &&
    !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(petform.value.petMail)
  ) {
    alert("Invalid email address");
    return false;
  }
  return true;
};
const setPetType = async (type) => {
  if (!type || petform.value.petType === type) {
    return;
  }
  petform.value.petType = type;
  petform.value.petCategory = ""; // 重置品种选择
  try {
    const success = await getBreedItems(type);

    if (success) {
      localStorage.removeItem("breed");
      petform.value.petCategory = "";
    } else {
      console.warn("品种列表加载失败，保留原有数据");
    }
  } catch (error) {
    console.error("加载品种列表失败:", error);
  }
};

const getBreedItems = async (type) => {
  try {
    const dictKey = "pet_category_" + type;
    const res = await api.common.getPetTypeDict(dictKey);
    const dictItems = res.data.data;
    breedItems.value = dictItems.map((item) => ({
      value: item.dictValue,
      label: item.dictValue,
    }));
    return true; // 返回成功状态
  } catch (error) {
    // 接口失败
    console.error("getBreedItems 接口请求失败:", error);
    return false; // 返回失败状态
  }
};

const openMsg = () => {
  showMsg.value = true;
};

const handleMessageSave = (message) => {
  petform.value.petMark = message;
  showMsg.value = false;
};

const handleSelectCode = (e) => {
  petform.value.phoneLocale = e.shortName;
  selectItem.value.countryCode = e.countryCode;
  selectItem.value.countryFlag = e.countryFlag;
  selectItem.value.countryName = e.countryName;
};

const locale = "en";
const localeMap = ref(new Map());
const localeItems = ref([
  {
    countryFlag: "",
    countryName: "Belgium",
    countryCode: "+32",
  },
]);
const loadLocaleItems = async () => {
  const country_locale_map = localStorage.getItem("country_locale");
  if (country_locale_map && country_locale_map !== "[]") {
    localeMap.value = new Map(JSON.parse(country_locale_map));
    localeItems.value = Array.from(localeMap.value.values());
    return;
  }
  return api.common
    .loadLocaleAreaCode(locale)
    .then((res) => {
      var items = res.data.data || [];
      const localMap = new Map();
      if (items.length === 0) {
        localMap.set("CN", {
          countryFlag: "0px 0px",
          countryName: "China",
          countryCode: "86",
          shortName: "CN",
        });
      }
      if (!items || items.length === 0) {
        return 0;
      }
      items.forEach((item) => localMap.set(item.shortName, item));
      localeItems.value = Array.from(localMap.values());
      localStorage.setItem(
        "country_locale",
        JSON.stringify(Array.from(localMap.entries())),
      );
      localeMap.value = localMap;
    })
    .finally(() => {
      console.log("loadLocaleItems", "加载完成");
    });
};

const handleCrop = (e) => {
  petPhoto.value = e
};

const base64ToBlob = (base64Data) => {
  // 分割Base64字符串
      if (!base64Data || !base64Data.includes("base64")) {
        return undefined;
      }
      const parts = base64Data.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;

      // 转换为ArrayBuffer
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      console.log(contentType )
      return new Blob([uInt8Array], {
        type: contentType
      });
};

const objectToFormDataDeep = (imageFile) => {
  const formData = new FormData();
  Object.entries(petform.value).forEach(([key, value]) => {
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value)
    } else if (value === null || value === undefined) {
      return
    } else if (Array.isArray(value)) {
      value.forEach(item => formData.append(`${key}[]`, item))
    } else if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  })
  if(imageFile && imageFile != null){
    formData.append("nofile", false)
    formData.append("image", imageFile)
  }
  return formData;
};

const checkRequired = () =>{
  if(!petform.value.petName){
    alert("Please enter your pet name")
    return false;
  }
  if(!petform.value.petBirthDate){
    alert("Please select your pet's birthdate")
    return false;
  }
  if(!petform.value.petCategory){
    alert("Please select one breed")
    return false;
  }
  if(!petform.value.petType){
    alert("Please select Type")
    return false;
  }
  if(!petform.value.petMail){
    alert("Please enter your email")
    return false;
  }
  if(!petform.value.petPhone){
    alert('Please enter you phone number')
    return false;
  }
  if(!petform.value.petMark){
    alert('Please select or enter your message')
    return false;
  }
  if(!petPhoto.value){
    alert("Please upload the image of pet")
    return false;
  }
  return true;
}

const submit = () => {
  if(!checkRequired()){
    return false;
  }
  const imageFile = base64ToBlob(petPhoto.value);
  const formData = objectToFormDataDeep(imageFile)
  console.log(petform.value)
  api.petTags.submitPet(formData).then(res =>{
    const result = res.data;
    if(result.code == 500){
      if(result.message == "Please select your pet's birthdate"){
          alert("Please select your pet's birthdate")
          return;
      }
      alert("Request failed!")
      return;
    }

    location.href = '/idtags?petid='+res.data.data?.petZcode+"&id="+ res.data.data?.id
  })
};
</script>

<style lang="css" scoped>
.date-input {
  width: 320px;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
}
/* 可以添加样式 */
.w3l-banner-background {
  width: 100%;
  min-height: 100vh;
  background: url(../assets/images/petsbg.png) no-repeat center;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;

  /* transition: background-img 1s ease-in-out; */
}

.my-blur-mask {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: url("../assets/images/petsbgmask.png") no-repeat center;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
}

.my-msg {
  position: relative;
  width: 360px;
  height: auto;
  margin: 0 auto;
}

.mypet-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 880px;
  gap: 20px;
  z-index: 100;
}

@media (max-width: 895px) {
  .mypet-container {
    flex-direction: column;
    gap: 5px;
    height: 760px;
    z-index: 1;
  }
}

.mypet {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 880px;
  height: 100%;
  border-radius: 20px;
}

.mypet-left {
  width: 400px;
  background-size: cover;
}
.mypet-right {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px 30px;
  align-items: flex-start; /* 单行内元素顶部对齐 */
  align-content: flex-start; /* 所有多行整体贴顶部，不垂直居中 */
  background-color: #fff;
}

.mypet-right-items {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 200px;
  color: var(--secondary-color);
}

.btn {
  width: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
}

.btn2 {
  flex: 1;
  width: 100%;
  border-radius: 60px;
  border: none;
  color: white;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 18px;
}

.mypet-right-item {
  display: flex;
  flex: 1;
}

.mypet-right-item-title {
  font-size: 15px;
  font-weight: bold;
  padding: 5px;
  width: 88px;
  text-align: right;
  align-items: center;
  justify-content: right;
  display: flex;
  color: #000;
}

.mypet-right-item-content {
  font-size: 15px;
  padding: 5px;
}

.action-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  width: 200px;
  height: 100%;
  margin-bottom: 15px;
  border-radius: 60px;
  border: none;
  color: white;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  font-size: 18px;
}
.action-item-phone {
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
  /* 主渐变 */
}

.text-item {
  flex: 1;
  border-radius: 6px;
  border: 1px solid #e7e1d7;
  padding-left: 5px;
  align-items: center;
}

.pet-type {
  display: flex;
  flex: 1;
  margin-bottom: 3px;
  font-size: 14px;
}

.tag-pic {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  vertical-align: middle;
}

.type-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 2px 0;
  border: 2px solid #e7e1d7;
  border-radius: 8px;
  margin-right: 15px;
  color: #d2cab9;
}

.type-item:last-child {
  margin-right: 0;
}

.active {
  background-color: #fff;
  border-color: #b55652;
  color: #b55652;
}

@media (max-width: 895px) {
  .mypet {
    width: 320px;
    height: auto;
  }
  .mypet-right {
    width: 320px;
    height: 320px;
    padding: 5px 15px;
  }
  .mypet-right-item-title {
    font-size: 12px;
    width: 60px;
  }
  .text-item {
    font-size: 12px;
  }
}
:deep(.dp__input_wrap) {
  position: relative;
  width: 100%;
  box-sizing: unset;
  border: 1px solid #e7e1d7;
  border-radius: 6px;
  flex: 1;
}
:deep(.dp__action_select) {
  background: linear-gradient(to bottom, #f03b34 0%, #8e0807 100%);
  color: var(--dp-primary-text-color);
}
</style>
